import { gateway } from '../../../gateway';
import { FlowTask, TaskPriority, TaskStatus } from '../interfaces/flowTask.interface';

export type CreateFlowTaskInput = {
  kanbanCategoryUid: string;
  name: string;
  description?: string;
  status: TaskStatus;
  priority: TaskPriority;
  deadline?: string;
};

export const createTodoTaskAction = async (task: CreateFlowTaskInput): Promise<FlowTask> => {
  try {
    if (!task.kanbanCategoryUid) {
      throw new Error('Kanban category UID is required');
    }
    if (!task.name || !task.name.trim()) {
      throw new Error('Task name is required');
    }
    if (!task.status || !task.priority) {
      throw new Error('Task status and priority are required');
    }

    const requestBody = {
      kanbanCategoryUid: task.kanbanCategoryUid,
      name: task.name.trim(),
      description: task.description || undefined,
      status: task.status,
      priority: task.priority,
      deadline: task.deadline || undefined,
    };

    const response = await gateway.post('/todo-tasks/self', requestBody);

    const createdTask = response.data?.data || response.data;
    if (!createdTask) throw new Error('Invalid response from server');

    // Ensure description is present for consistency with FlowTask interface
    if (createdTask.description && !createdTask.description) {
      createdTask.description = createdTask.description;
    }

    return createdTask;
  } catch (error: any) {
    console.error('Error creating todo task:', error);
    const errorMessage =
      error?.response?.data?.message || error?.message || 'Failed to create todo task';
    throw new Error(errorMessage);
  }
};
